import React, { useState } from 'react';
import { Image } from 'react-bootstrap';
import { UserOutlined } from '@ant-design/icons';

const Avatar = ({ 
  user, 
  size = 32, 
  className = '',
  style = {},
  showBorder = false 
}) => {
  const avatar = user?.avatarBase64 || user?.avatar;
  const [imageError, setImageError] = useState(false);
  const defaultSize = size || 32;
  
  const avatarStyle = {
    width: defaultSize,
    height: defaultSize,
    borderRadius: '50%',
    objectFit: 'cover',
    border: showBorder ? '2px solid #dee2e6' : 'none',
    ...style,
  };

  const iconStyle = {
    width: defaultSize,
    height: defaultSize,
    borderRadius: '50%',
    backgroundColor: '#f0f0f0',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    border: showBorder ? '2px solid #dee2e6' : 'none',
    color: '#6c757d',
    fontSize: defaultSize * 0.5,
    ...style,
  };

  if (avatar && !imageError) {
    // Проверяем, является ли аватар URL или base64
    let avatarUrl;
    if (avatar.startsWith('http://') || avatar.startsWith('https://')) {
      avatarUrl = avatar;
    } else if (avatar.startsWith('data:')) {
      avatarUrl = avatar;
    } else if (avatar.startsWith('/')) {
      const baseUrl = process.env.NODE_ENV === 'development'
        ? 'http://92.63.106.142:4000'
        : '';
      avatarUrl = `${baseUrl}${avatar}`;
    } else {
      // Предполагаем, что это base64 без префикса
      avatarUrl = `data:image/jpeg;base64,${avatar}`;
    }
    
    return (
      <Image
        src={avatarUrl}
        alt={user?.login || user?.username || 'User'}
        style={avatarStyle}
        className={className}
        onError={() => {
          setImageError(true);
        }}
      />
    );
  }

  return (
    <div style={iconStyle} className={className}>
      <UserOutlined />
    </div>
  );
};

export default Avatar;

